<template>
    <div class="eval_page">
        <h1>职业目标规划</h1>
        <div class="pos_target_category">
            <div class="pos_target_btn_category">
                <div class="pos_target_main_info_layout_div info_position">
                    <div class="pos_target_info_layout_div">
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">序号</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">是否为HR职位</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">目标职位</label>
                        </div>
                        <div class="pos_target_info_cell_big">
                            <label style="font-size: medium">目标年份</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">目标年薪</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">企业规模</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">目标行业</label>
                        </div>
                    </div>
                    <div class="pos_target_info_layout_div">
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">1</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <el-checkbox v-model="is_hr_position_1"></el-checkbox>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="position_1">
                                <option v-for="(pos, index) in is_hr_position_1?hr_positions:positions" :key="index" :value="pos['id']"
                                        :data-id="pos['id']">
                                    {{ pos['name'] }}
                                </option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell_big">
                            <el-date-picker type="year" v-model="target_data_1"></el-date-picker>
                        </div>
                        <div class="pos_target_info_cell">
                            <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_1">
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="company_size_1">
                                <option value="大型">大型</option>
                                <option value="中型">中型</option>
                                <option value="小型">小型</option>
                                <option value="微型">微型</option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="industry_1">
                                <option v-for="(ind, index) in industries" :key="index" :value="ind['id']"
                                        :data-id="ind['id']">
                                    {{ ind['name'] }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="pos_target_info_layout_div">
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">2</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <el-checkbox v-model="is_hr_position_2"></el-checkbox>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="position_2">
                                <option v-for="(pos, index) in is_hr_position_2?hr_positions:positions" :key="index" :value="pos['id']"
                                        :data-id="pos['id']">
                                    {{ pos['name'] }}
                                </option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell_big">
                            <el-date-picker type="year" v-model="target_data_2"></el-date-picker>
                        </div>
                        <div class="pos_target_info_cell">
                            <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_2">
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="company_size_2">
                                <option value="大型">大型</option>
                                <option value="中型">中型</option>
                                <option value="小型">小型</option>
                                <option value="微型">微型</option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="industry_2">
                                <option v-for="(ind, index) in industries" :key="index" :value="ind['id']"
                                        :data-id="ind['id']">
                                    {{ ind['name'] }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="pos_target_info_layout_div">
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">3</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <el-checkbox v-model="is_hr_position_3"></el-checkbox>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="position_3">
                                <option v-for="(pos, index) in is_hr_position_3?hr_positions:positions" :key="index" :value="pos['id']"
                                        :data-id="pos['id']">
                                    {{ pos['name'] }}
                                </option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell_big">
                            <el-date-picker type="year" v-model="target_data_3"></el-date-picker>
                        </div>
                        <div class="pos_target_info_cell">
                            <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_3">
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="company_size_3">
                                <option value="大型">大型</option>
                                <option value="中型">中型</option>
                                <option value="小型">小型</option>
                                <option value="微型">微型</option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="industry_3">
                                <option v-for="(ind, index) in industries" :key="index" :value="ind['id']"
                                        :data-id="ind['id']">
                                    {{ ind['name'] }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="pos_target_info_layout_div">
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">4</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <el-checkbox v-model="is_hr_position_4"></el-checkbox>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="position_4">
                                <option v-for="(pos, index) in is_hr_position_4?hr_positions:positions" :key="index" :value="pos['id']"
                                        :data-id="pos['id']">
                                    {{ pos['name'] }}
                                </option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell_big">
                            <el-date-picker type="year" v-model="target_data_4"></el-date-picker>
                        </div>
                        <div class="pos_target_info_cell">
                            <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_4">
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="company_size_4">
                                <option value="大型">大型</option>
                                <option value="中型">中型</option>
                                <option value="小型">小型</option>
                                <option value="微型">微型</option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="industry_4">
                                <option v-for="(ind, index) in industries" :key="index" :value="ind['id']"
                                        :data-id="ind['id']">
                                    {{ ind['name'] }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="pos_target_info_layout_div">
                        <div class="pos_target_info_cell">
                            <label style="font-size: medium">5</label>
                        </div>
                        <div class="pos_target_info_cell">
                            <el-checkbox v-model="is_hr_position_5"></el-checkbox>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="position_5">
                                <option v-for="(pos, index) in is_hr_position_5?hr_positions:positions" :key="index" :value="pos['id']"
                                        :data-id="pos['id']">
                                    {{ pos['name'] }}
                                </option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell_big">
                            <el-date-picker type="year" v-model="target_data_5"></el-date-picker>
                        </div>
                        <div class="pos_target_info_cell">
                            <input placeholder="人民币：圆" type="text" class="form-control" v-model="salary_5">
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="company_size_5">
                                <option value="大型">大型</option>
                                <option value="中型">中型</option>
                                <option value="小型">小型</option>
                                <option value="微型">微型</option>
                            </select>
                        </div>
                        <div class="pos_target_info_cell">
                            <select class="form-control work_select" v-model="industry_5">
                                <option v-for="(ind, index) in industries" :key="index" :value="ind['id']"
                                        :data-id="ind['id']">
                                    {{ ind['name'] }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="eval_buttons_navi">
                    <button class="save_button" @click="complete_step()">完成</button>
                </div>
                <div style="clear: both"></div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'
    // import laydate from 'laydate'

    export default {
        data: function () {
            return {
                position_1: '',
                is_hr_position_1: '',
                industry_1: '',
                salary_1: '',
                company_size_1: '',
                target_data_1: '',
                position_2: '',
                is_hr_position_2: '',
                industry_2: '',
                salary_2: '',
                company_size_2: '',
                target_data_2: '',
                position_3: '',
                is_hr_position_3: '',
                industry_3: '',
                salary_3: '',
                company_size_3: '',
                target_data_3: '',
                position_4: '',
                is_hr_position_4: '',
                industry_4: '',
                salary_4: '',
                company_size_4: '',
                target_data_4: '',
                position_5: '',
                is_hr_position_5: '',
                industry_5: '',
                salary_5: '',
                company_size_5: '',
                target_data_5: '',
            }
        },
        methods: {
            ...mapActions({
                set_start_btn_infos: 'position_target/set_state_btn_info',
                // click_btn_js: 'position_target/click_btn',
                save_info: 'position_target/save_info',
                // change_warning_message: 'warningBar/change_message',
                // change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class',
                // previous_step_js: 'position_target/previous_step',
                // next_step_js: 'position_target/next_step',
                // set_window_4_info: 'position_target/set_window_4_info',
            }),
            click_btn: function (event) {
                let state = event.target.getAttribute('data-state')
                let id = event.target.getAttribute('data-id')
                if (state === '4') {
                    if (id === '0') {
                        this.first_position = this.first_position_line[1]
                    } else {
                        this.first_position = this.first_position_line[0]
                    }
                } else if (state === '0') {
                    if (id === '0') {
                        this.position = this.position_line[1]
                    } else {
                        this.position = this.position_line[0]
                    }
                }
                console.log(this.position, this.position_line, id, state, this.is_hr_worker, 'test')
                this.click_btn_js(event)
            },
            click_info_btn: function (event) {
                // let state = event.target.getAttribute('data-state')
                this.position = event.target.getAttribute('data-id')
                this.step1 = true
            },
            click_edu_btn: function (event) {
                // let state = event.target.getAttribute('data-state')
                this.education = event.target.getAttribute('data-id')
                this.step1 = true
            },
            click_cs_btn: function (event) {
                // let state = event.target.getAttribute('data-state')
                this.company_size = event.target.getAttribute('data-id')
                this.step1 = true
            },
            previous_step: function (event) {
                this.step1 = false
                this.step2 = false
                // let id = event.target.getAttribute('data-id')
                // if (id === '1'){
                //     // let target = event.target.parentNode.parentNode.childNodes
                //     let target = event.target.parentNode.parentNode.previousSibling.childNodes
                //     console.log(target.length,event.target,target[1].firstChild, 'target')
                //     target[1].firstChild.focus()
                //     for (let i=0; i<target.length;i++){
                //         if (target[i].className === 'eval_options_list'){
                //             console.log(target[i].firstChild)
                //         }
                //     }
                // }
                this.previous_step_js(event)
            },
            next_step: function (event) {
                this.step1 = false
                this.step2 = false
                let that = this
                let id = event.target.getAttribute('data-id')
                if (id === '2') {
                    this.set_window_4_info([this.position_data, this.position]).then(function () {
                        that.next_step_js(event)
                    })
                } else {
                    this.next_step_js(event)
                }
            },
            complete_step: function () {
                let obj = {'target_1':
                    {
                    'position': this.position_1,
                    'is_hr_position': this.is_hr_position_1,
                    'target_date': this.target_data_1,
                    'salary': this.salary_1,
                    'industry': this.industry_1,
                    'company_size': this.company_size_1},'target_2':{
                    'position': this.position_2,
                    'is_hr_position': this.is_hr_position_2,
                    'target_date': this.target_data_2,
                    'salary': this.salary_2,
                    'industry': this.industry_2,
                    'company_size': this.company_size_2},'target_3':{
                    'position': this.position_3,
                    'is_hr_position': this.is_hr_position_3,
                    'target_date': this.target_data_3,
                    'salary': this.salary_3,
                    'industry': this.industry_3,
                    'company_size': this.company_size_3},'target_4':{
                    'position': this.position_4,
                    'is_hr_position': this.is_hr_position_4,
                    'target_date': this.target_data_4,
                    'salary': this.salary_4,
                    'industry': this.industry_4,
                    'company_size': this.company_size_4},'target_5':{
                    'position': this.position_5,
                    'is_hr_position': this.is_hr_position_5,
                    'target_date': this.target_data_5,
                    'salary': this.salary_5,
                    'industry': this.industry_5,
                    'company_size': this.company_size_5}
                    }
                console.log(obj)
                let that = this
                this.save_info(obj).then(function () {
                    localStorage.setItem('field', '')
                    that.$router.push({name: 'position_target_state'})
                })
            }
        },
        computed: {
            ...mapState({
                positions: state => state.position_target.positions,
                hr_positions: state => state.position_target.hr_positions,
                industries: state => state.position_target.industries,
                user_info: state => state.position_target.user_info,
            })
        },
        mounted: function () {
            let that = this
            this.set_start_btn_infos()
            this.set_start_btn_infos().then(function () {
                let count = that.user_info.length
                if (count >= 1){
                    if (that.user_info[0]['position_line_id']){
                        that.is_hr_position_1 = true
                        that.position_1 = that.user_info[0]['position_line_id']
                    }else{
                        that.is_hr_position_1 = false
                        that.position_1 = that.user_info[0]['position_id']
                    }
                    that.target_data_1 = that.user_info[0]['target_date']
                    that.salary_1 = that.user_info[0]['salary']
                    that.industry_1 = that.user_info[0]['industry']
                    that.company_size_1 = that.user_info[0]['company_size']
                }
                if (count >= 2){
                    if (that.user_info[1]['position_line_id']){
                        that.is_hr_position_2 = true
                        that.position_2 = that.user_info[1]['position_line_id']
                    }else{
                        that.is_hr_position_2 = false
                        that.position_2 = that.user_info[1]['position_id']
                    }
                    that.target_data_2 = that.user_info[1]['target_date']
                    that.salary_2 = that.user_info[1]['salary']
                    that.industry_2 = that.user_info[1]['industry']
                    that.company_size_2 = that.user_info[1]['company_size']
                }
                if (count >= 3){
                    if (that.user_info[2]['position_line_id']){
                        that.is_hr_position_3 = true
                        that.position_3 = that.user_info[2]['position_line_id']
                    }else{
                        that.is_hr_position_3 = false
                        that.position_3 = that.user_info[2]['position_id']
                    }
                    that.target_data_3 = that.user_info[2]['target_date']
                    that.salary_3 = that.user_info[2]['salary']
                    that.industry_3 = that.user_info[2]['industry']
                    that.company_size_3 = that.user_info[2]['company_size']
                }
                if (count >= 4){
                    if (that.user_info[3]['position_line_id']){
                        that.is_hr_position_4 = true
                        that.position_4 = that.user_info[3]['position_line_id']
                    }else{
                        that.is_hr_position_4 = false
                        that.position_4 = that.user_info[3]['position_id']
                    }
                    that.target_data_4 = that.user_info[3]['target_date']
                    that.salary_4 = that.user_info[3]['salary']
                    that.industry_4 = that.user_info[3]['industry']
                    that.company_size_4 = that.user_info[3]['company_size']
                }
                if (count >= 5){
                    if (that.user_info[4]['position_line_id']){
                        that.is_hr_position_5 = true
                        that.position_5 = that.user_info[4]['position_line_id']
                    }else{
                        that.is_hr_position_5 = false
                        that.position_5 = that.user_info[4]['position_id']
                    }
                    that.target_data_5 = that.user_info[4]['target_date']
                    that.salary_5 = that.user_info[4]['salary']
                    that.industry_5 = that.user_info[4]['industry']
                    that.company_size_5 = that.user_info[4]['company_size']
                }

            })
        }
    }

</script>
<style type="text/css">
    .eval_page {
        width: 1170px;
        height: 100%;
        margin: auto;
        padding: 16px;
    }

    .eval_page > h1 {
        padding-left: 72px;
        color: #fff;
    }

    .pos_target_category {
        text-align: center;
        width: 1000px;
        margin: 8px auto;
        padding: 16px 0;
        background: #fff 50%;
        min-height: 540px;
        border: #3e83c5 1px;
        border-radius: 10px;
    }

    .eval_options_list {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 10px;
        /*float: left;*/
    }

    .eval_options_list_half {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 10px;
        width: 50%;
        float: left;
    }

    .eval_options_list_quarter {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 10px;
        width: 25%;
        float: left;
    }

    .save_button {
        margin-left: 50px;
        margin-right: 50px;
        color: #fff;
        border-color: #66CCFF;
        background-color: #66CCFF;
        border: 1px solid transparent;
        padding: .375rem 2rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .save_button:hover {
        color: #fff;
        border-color: #068e6c;
        background-color: #068e6c;
    }

    .pos_target_main_info_layout_div {
        display: inline-block;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        width:100%
    }
    .pos_target_info_layout_div {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 10px;

    }
    .pos_target_info_cell {
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        margin-left: 20px;
        width:12%
    }
    .pos_target_info_cell_big {
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        margin-left: 20px;
        width:30%
    }

    .ruby_div {
        display: ruby;
    }

    .eval_options_flow {
        display: flow-root;
    }

    .eval_buttons_navi {
        display: inline-block;
        align-items: center;
        position: relative;
        margin: 20px;
    }

    .eval_buttons_navi > button {
        border-radius: 22px;
    }

    .main_info_rate_layout_div {
        display: inline;
        width: 25%;
        align-items: center;
        /*position: relative;*/
        margin-bottom: 20px;
    }

    .main_info_rate_layout_div_in {
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
    }

    .main_info_label {
        padding-right: 5px;
        padding-left: 5px;
        padding-top: calc(.375rem + 1px);
        padding-bottom: calc(.375rem + 1px);
        margin-bottom: 0;
        font-size: 1rem;
        line-height: 1.5;
        max-width: 16.66666%;
        flex: 0 0 16.6666%;
    }

    .question_label {
        font-size: 1.5rem;
        min-height: 3rem;
    }

    .main_info_rate_label {
        white-space: nowrap;
        padding-right: 5px;
        padding-left: 5px;
        padding-top: calc(.375rem + 1px);
        padding-bottom: calc(.375rem + 1px);
        margin-bottom: 0;
        font-size: 1rem;
        line-height: 1.5;
        width: 80%;
        flex: 0 0 16.6666%;
    }

    .main_info_rate_value_label {
        padding-right: 5px;
        padding-left: 5px;
        padding-top: calc(.375rem + 1px);
        padding-bottom: calc(.375rem + 1px);
        margin-bottom: 0;
        float: right;
        font-size: 1rem;
        line-height: 1.5;
        width: 20%;
        flex: 0 0 16.6666%;
    }

    .work_select :after {
        content: "333";
        width: 1rem;
        height: 1rem;
        position: absolute;
    }
    .el-input__inner{
        height: 30px;
        width: 200px;
    }

    .work_select {
        appearance: none;
        background: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E") no-repeat right .75rem center/8px 10px;
    }

    .eval_options_list_hide {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        position: relative;
        padding: 10px 40px;
        display: none;
    }

    .info_btn {
        background: #dde6eb;
        background-image: -webkit-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: -moz-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: -ms-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: -o-linear-gradient(top, #dde6eb, #b0c1cc);
        background-image: linear-gradient(to bottom, #dde6eb, #b0c1cc);
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        font-family: Arial;
        color: #ffffff;
        font-size: 20px;
        padding: 6px 15px 6px 15px;
        border: solid #acc9e5 1px;
        min-width: 120px;
        text-decoration: none;
    }

    .info_btn:hover {
        background: #2980b9;
        background-image: -webkit-linear-gradient(top, #2980b9, #3498db);
        background-image: -moz-linear-gradient(top, #2980b9, #3498db);
        background-image: -ms-linear-gradient(top, #2980b9, #3498db);
        background-image: -o-linear-gradient(top, #2980b9, #3498db);
        background-image: linear-gradient(to bottom, #2980b9, #3498db);
        color: #ffffff;
        text-decoration: none;
    }

    .info_btn:focus {
        background: #69c060;
        background-image: -webkit-linear-gradient(top, #69c060, #74d688);
        background-image: -moz-linear-gradient(top, #69c060, #74d688);
        background-image: -ms-linear-gradient(top, #69c060, #74d688);
        background-image: -o-linear-gradient(top, #69c060, #74d688);
        background-image: linear-gradient(to bottom, #69c060, #74d688);
        color: #ffffff;
        text-decoration: none;
    }

    .info_btn_selected {
        background: #69c060;
        background-image: -webkit-linear-gradient(top, #69c060, #74d688);
        background-image: -moz-linear-gradient(top, #69c060, #74d688);
        background-image: -ms-linear-gradient(top, #69c060, #74d688);
        background-image: -o-linear-gradient(top, #69c060, #74d688);
        background-image: linear-gradient(to bottom, #69c060, #74d688);
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
        font-family: Arial;
        color: #ffffff;
        font-size: 20px;
        padding: 6px 15px 6px 15px;
        border: solid #acc9e5 1px;
        min-width: 120px;
        text-decoration: none;
    }

    .eval_box_div_show {
        display: flex;
        flex-direction: column;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 30%;
    }

    .eval_box_div_hide {
        display: none;
    }

    .eval_rate_div_show {
        display: flex;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
    }

    .eval_rate_div_hide {
        display: none;
    }

    .pos_target_btn_category {
        display: block;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        width: 90%;
    }

    .eval_btn_category_hide {
        display: none;
    }

    .skill_category_title {
        font-size: 16px;
        color: #666;
        width: 62px;
        min-width: 62px;
        margin-top: 2px;
    }

    .skill_category {
        width: 1170px;
        padding: 0 5px;
        margin-left: auto;
        margin-right: auto;
    }

    .skill_category_div {
        width: 100%;
        background: #fff;
        padding: 20px;
        border: 1px solid #eee;
        margin-bottom: 10px;
    }

    .skill_selection {
        display: flex;
        margin-bottom: 10px;
        /*flex-wrap: wrap;*/
    }

    .skill_category_tag {
        /*border-bottom: 2px solid #eee;*/
        /*margin-bottom: 0;*/
        /*padding-bottom: 10px;*/
    }

    .skill_selection_card {
        display: flex;
        flex-wrap: wrap;
    }

    .libary_main_libray_content_cards {
        display: flex;
        flex-wrap: wrap;
        background: #fff;
    }

    .libary_main_libray_cards {
        display: flex;
        flex-wrap: wrap;
    }

    .libray_main_library_content_card {
        width: 33%;
        padding: 10px 15px;
    }

    .complete {
        padding: .375rem .5rem;
        color: #fff;
        background: #66CCFF;
        border: 1px solid #59C0F0;
        width: 100px;
        font-size: 1rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
    }

    .rate_table {
        border-collapse: collapse;
        text-align: center;
        table-layout: fixed;
        width: 1000px;
        margin-left: auto;
        margin-right: auto;
    }

    .div_block {
        display: block;
    }

</style>
